// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26pvN","image":"Header_image__1BuCi","name":"Header_name__3Jq4W","info":"Header_info__39IQH","infoRow":"Header_infoRow__2oT8u"};